import React from "react";
import { useTranslation } from "react-i18next";
import { Edit as EditInterface } from '../../../../interfaces/invoice.interface';
import { Tooltip } from "@mui/material";
import Badge from "../../../../components/Badge";

interface CardsProps {
  formData: EditInterface;
}

const Cards: React.FC<CardsProps> = ({ formData }) => {
  const { t } = useTranslation()

  return (
    <div className="row g-4 mb-1">
      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-info mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-info rounded-3">
                  <i className="ri-file-add-line ri-22px"></i>
                </div>
              </div>
              <div className="card-info">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{formData.createdBy || '-'}</h6>
                </div>
                <p className="mb-0">{formData.createdDate || '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="info"
              style={{
                borderRadius: '0px 10px 0px 10px'
              }}
              text={t("invoices.editPreviewPayment.pageTexts.form.createdBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-primary mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-primary rounded-3">
                  <i className="ri-pencil-line ri-22px"> </i>
                </div>
              </div>
              <div className="card-primary">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{formData.updatedBy || '-'}</h6>
                </div>
                <p className="mb-0">{formData.createdDate || '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="primary"
              style={{
                borderRadius: '0px 10px 0px 10px'
              }}
              text={t("invoices.editPreviewPayment.pageTexts.form.updatedBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-warning mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-warning rounded-3">
                  <i className="ri-send-plane-line ri-22px"> </i>
                </div>
              </div>
              <div className="card-warning">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{formData.sentBy || t("invoices.editPreviewPayment.pageTexts.form.notSentYet")}</h6>
                </div>
                <p className="mb-0">{formData.sentDate || '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="warning"
              style={{
                borderRadius: '0px 10px 0px 10px'
              }}
              text={t("invoices.editPreviewPayment.pageTexts.form.sentBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-success mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-success rounded-3">
                  <i className="ri-check-double-line ri-22px"> </i>
                </div>
              </div>
              <div className="card-success">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{formData.completedBy || t("invoices.editPreviewPayment.pageTexts.form.notCompletedYet")}</h6>
                </div>
                <p className="mb-0">{formData.completedDate || '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="success"
              style={{
                borderRadius: '0px 10px 0px 10px'
              }}
              text={t("invoices.editPreviewPayment.pageTexts.form.completedBy")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;